if (!customElements.get('media-slider')) {
  customElements.define(
    'media-slider',
    class MediaSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);

        this.main = this.querySelector('.media-testimonials');
        this.thumbs = this.querySelector('.media-thumbs');

        this.mainSlider = this.main.querySelector('.swiper');
        this.thumbsSlider = this.thumbs.querySelector('.swiper');

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        this.destroySlider();
        this.initSlider();
      }

      setSliderOptions() {
        this.mainOptions = {
          autoHeight: true,
          slidesPerView: 1,
          spaceBetween: 30,
          navigation: {
            nextEl: this.main.querySelector('.swiper-button-next'),
            prevEl: this.main.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.section.querySelector('.swiper-pagination'),
            clickable: true,
          },
          loop: true,
          threshold: 2,
          grabCursor: true,
          allowTouchMove: true,
        };

        const thumbsDesktopItems = Number(this.thumbs.dataset.itemsDesktop);
        const thumbsTabletItems = Number(this.thumbs.dataset.itemsTablet);

        this.thumbsOptions = {
          slidesPerView: 1,
          spaceBetween: 32,
          breakpoints: {
            768: {
              slidesPerView: thumbsTabletItems,
              spaceBetween: 90,
            },
            1024: {
              slidesPerView: thumbsDesktopItems,
              spaceBetween: 90,
            },
          },
          freeMode: true,
          threshold: 2,
        };

        if (FoxTheme.config.mqlMobile) {
          this.thumbsOptions = Object.assign({}, this.thumbsOptions, {
            loop: false,
            allowTouchMove: false,
          });
        }
      }

      initSlider() {
        requestAnimationFrame(() => {
          this.setSliderOptions();
          this.thumbsInstance = new FoxTheme.Carousel(this.thumbsSlider, this.thumbsOptions);
          this.thumbsInstance.init();

          this.mainOptions.thumbs = {
            swiper: this.thumbsInstance.slider,
          };

          this.sliderInstance = new FoxTheme.Carousel(
            this.mainSlider,
            this.mainOptions,
            [FoxTheme.Swiper.Thumbs]
          );
          this.sliderInstance.init();

          this.sliderInstance.slider.on('realIndexChange', (swiper) => {
            const { realIndex } = swiper;
            const thumbsSwiper = this.thumbsInstance.slider;

            if (thumbsSwiper && typeof thumbsSwiper.slideTo === 'function') {
              thumbsSwiper.slideTo(realIndex);
            }
          });
        });
      }


      destroySlider() {
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;

        this.thumbsInstance.slider.destroy();
        this.thumbsInstance = false;
      }
    }
  );
}
